import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var TaxControlerInfo = _.cloneDeepGet(_this, "oppBusiData.oldBusiData.TaxControlerInfo");
  if (!_.isEmpty(TaxControlerInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], TaxControlerInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var TaxControlerInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (TaxControlerInfo && TaxControlerInfo.length) {
    _.each(TaxControlerInfo, function (obj) {
      obj && (obj["UNGET_TAXPAYERID_REASON1"] || obj["UNGET_TAXPAYERID_REASON1"] == "") && (obj["NO_TAXPAYERID_REASON"] = obj["UNGET_TAXPAYERID_REASON1"]) && (obj["NO_TAXPAYERID_REASON_DATA_SOURCE"] = obj["UNGET_TAXPAYERID_REASON1_DATA_SOURCE"]) && (obj["NO_TAXPAYERID_REASON_UPDATE_FLAG"] = obj["UNGET_TAXPAYERID_REASON1_UPDATE_FLAG"]);
      obj && (obj["UNGET_TAXPAYERID_REASON2"] || obj["UNGET_TAXPAYERID_REASON2"] == "") && (obj["NO_TAXPAYERID_REASON2"] = obj["UNGET_TAXPAYERID_REASON2"]) && (obj["NO_TAXPAYERID_REASON2_DATA_SOURCE"] = obj["UNGET_TAXPAYERID_REASON2_DATA_SOURCE"]) && (obj["NO_TAXPAYERID_REASON2_UPDATE_FLAG"] = obj["UNGET_TAXPAYERID_REASON2_UPDATE_FLAG"]);
      obj && (obj["UNGET_TAXPAYERID_REASON3"] || obj["UNGET_TAXPAYERID_REASON3"] == "") && (obj["NO_TAXPAYERID_REASON3"] = obj["UNGET_TAXPAYERID_REASON3"]) && (obj["NO_TAXPAYERID_REASON3_DATA_SOURCE"] = obj["UNGET_TAXPAYERID_REASON3_DATA_SOURCE"]) && (obj["NO_TAXPAYERID_REASON3_UPDATE_FLAG"] = obj["UNGET_TAXPAYERID_REASON3_UPDATE_FLAG"]);

      obj && (obj["CITIZENSHIP"] || obj["CITIZENSHIP"] == "") && (obj["CITIZENSHIP_ST"] = obj["CITIZENSHIP"]) && (obj["CITIZENSHIP_ST_DATA_SOURCE"] = obj["CITIZENSHIP_DATA_SOURCE"]) && (obj["CITIZENSHIP_ST_UPDATE_FLAG"] = obj["CITIZENSHIP_UPDATE_FLAG"]);
      obj && (obj["CITIZENSHIP2"] || obj["CITIZENSHIP2"] == "") && (obj["CITIZENSHIP_ST2"] = obj["CITIZENSHIP2"]) && (obj["CITIZENSHIP_ST2_DATA_SOURCE"] = obj["CITIZENSHIP2_DATA_SOURCE"]) && (obj["CITIZENSHIP_ST2_UPDATE_FLAG"] = obj["CITIZENSHIP2_UPDATE_FLAG"]);
      obj && (obj["CITIZENSHIP3"] || obj["CITIZENSHIP3"] == "") && (obj["CITIZENSHIP_ST3"] = obj["CITIZENSHIP3"]) && (obj["CITIZENSHIP_ST3_DATA_SOURCE"] = obj["CITIZENSHIP3_DATA_SOURCE"]) && (obj["CITIZENSHIP_ST3_UPDATE_FLAG"] = obj["CITIZENSHIP3_UPDATE_FLAG"]);
    });
    _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][MODULE_ID], TaxControlerInfo);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      if (fieldAction == "DEFAULT_VALUE") {
        vm.$store.state.canCleanData && (item[fieldAction] = val);
      } else {
        item[fieldAction] = val;
      }
    };
  });
};
var SEL_NO_TAXPAYERID_REASON = [{
  DICT_ITEM: "1",
  DICT_ITEM_NAME: "居民国(地区)不发放纳税人识别号"
}, {
  DICT_ITEM: "2",
  DICT_ITEM_NAME: "账户持有人未能取得纳税人识别号"
}];

var setTaxfield = function setTaxfield(fields) {
  _.set(fields, "IS_TAXPAYER_IDNO_1.FIELD_TYPE", "radio");
  _.set(fields, "IS_TAXPAYER_IDNO_2.FIELD_TYPE", "radio");
  _.set(fields, "IS_TAXPAYER_IDNO_3.FIELD_TYPE", "radio");
  _.set(fields, "SEL_NO_TAXPAYERID_REASON1.FIELD_DICT_NAME", SEL_NO_TAXPAYERID_REASON);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON2.FIELD_DICT_NAME", SEL_NO_TAXPAYERID_REASON);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON3.FIELD_DICT_NAME", SEL_NO_TAXPAYERID_REASON);
  _.set(fields, "CITIZENSHIP_ST.FIELD_TYPE", "selector");
  _.set(fields, "CITIZENSHIP_ST2.FIELD_TYPE", "selector");
  _.set(fields, "CITIZENSHIP_ST3.FIELD_TYPE", "selector");
  _.set(fields, "REG_COUNTRY.FIELD_TYPE", "selector");
  _.set(fields, "BIRTH_NATION_ENG.FIELD_TYPE", "selector");
  _.set(fields, "NATION_ENG.FIELD_TYPE", "selector");

  _.set(fields, "TAXPAYER_IDNO.isLongItem", false);
  _.set(fields, "TAXPAYER_IDNO2.isLongItem", false);
  _.set(fields, "TAXPAYER_IDNO3.isLongItem", false);

  _.set(fields, "SEL_NO_TAXPAYERID_REASON1.isLongItem", false);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON2.isLongItem", false);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON3.isLongItem", false);
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  var tempFields = _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].FIELDS;
  setTaxfield(fields);
  setTaxfield(tempFields);
  _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
  _this.groupDatasTpl.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
  _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].MODULE_CONTROL = "0";
  fields.CUST_NAME.VALID_TYPE = "length[0, 256]";
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var custTaxInfo, oldTaxInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              custTaxInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH]);
              oldTaxInfo = _.get(params, "" + SAVE_PATH) || [];


              if (["1", "2"].indexOf(_this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.PASSIVE_NFE.DEFAULT_VALUE) > -1) {
                if (!_.isArray(custTaxInfo)) {
                  custTaxInfo = [custTaxInfo];
                }
                _.each(custTaxInfo, function (item, index) {
                  oldTaxInfo = oldTaxInfo[index] || {};
                  item.PASSIVE_NFE = "3", item.TAXPAYER_IDNO1 = item.TAXPAYER_IDNO;
                  item.ADDRESS_TYPE = "";
                  item.CITIZENSHIP_CN = "";
                  item["UNGET_TAXPAYERID_REASON1"] = item["NO_TAXPAYERID_REASON"];
                  item["UNGET_TAXPAYERID_REASON2"] = item["NO_TAXPAYERID_REASON2"];
                  item["UNGET_TAXPAYERID_REASON3"] = item["NO_TAXPAYERID_REASON3"];


                  delete item["NO_TAXPAYERID_REASON"];
                  delete item["NO_TAXPAYERID_REASON2"];
                  delete item["NO_TAXPAYERID_REASON3"];
                  item["CITIZENSHIP"] = item["CITIZENSHIP_ST"];
                  item["CITIZENSHIP2"] = item["CITIZENSHIP_ST2"];
                  item["CITIZENSHIP3"] = item["CITIZENSHIP_ST3"];

                  delete item["CITIZENSHIP_ST"];
                  delete item["CITIZENSHIP_ST2"];
                  delete item["CITIZENSHIP_ST3"];
                  item.BIRTH_COUNTRY = "";
                  item.LIVING_COUNTRY = item.NATION_ENG || "";
                  item.CTRL_FLAG = "0";
                  item.CTRL_NON_RESIDENT = item.TAX_RESIDENT_TYPE === "1" ? "0" : "1";
                  item.FULL_BIRTHD_ADDRESS_ENG = "";

                  item.NO_TAXPAYERID_REASON = item["SEL_NO_TAXPAYERID_REASON1"] ? (SEL_NO_TAXPAYERID_REASON[item["SEL_NO_TAXPAYERID_REASON1"] - 1]["DICT_ITEM_NAME"] || "") + (item["UNGET_TAXPAYERID_REASON1"] ? ":" + item["UNGET_TAXPAYERID_REASON1"] : item["UNGET_TAXPAYERID_REASON1"]) : "";
                  item.NO_TAXPAYERID_REASON2 = item["SEL_NO_TAXPAYERID_REASON2"] ? (SEL_NO_TAXPAYERID_REASON[item["SEL_NO_TAXPAYERID_REASON2"] - 1]["DICT_ITEM_NAME"] || "") + (item["UNGET_TAXPAYERID_REASON2"] ? ":" + item["UNGET_TAXPAYERID_REASON2"] : item["UNGET_TAXPAYERID_REASON2"]) : "";
                  item.NO_TAXPAYERID_REASON3 = item["SEL_NO_TAXPAYERID_REASON3"] ? (SEL_NO_TAXPAYERID_REASON[item["SEL_NO_TAXPAYERID_REASON3"] - 1]["DICT_ITEM_NAME"] || "") + (item["UNGET_TAXPAYERID_REASON3"] ? ":" + item["UNGET_TAXPAYERID_REASON3"] : item["UNGET_TAXPAYERID_REASON3"]) : "";
                  item.SEL_NO_TAXPAYERID_REASON1_TEXT = item.NO_TAXPAYERID_REASON;
                  item.SEL_NO_TAXPAYERID_REASON2_TEXT = item.NO_TAXPAYERID_REASON2;
                  item.SEL_NO_TAXPAYERID_REASON3_TEXT = item.NO_TAXPAYERID_REASON3;


                  if (item.TAX_RESIDENT_TYPE == "1") {
                    item.CITIZENSHIP_CN = "CN";
                    item.CITIZENSHIP = "CN";
                    item.NATION_ENG = "CN";
                  }

                  item.FULL_ADDRESS_ENG = "";
                  if (!!item.NATION_ENG && item.TAX_RESIDENT_TYPE !== "1") {
                    item.FULL_ADDRESS_ENG = item.NATION_ENG + "(国家)";
                  }
                  if (!!item.PROVINCE_ENG) {
                    item.FULL_ADDRESS_ENG = item.FULL_ADDRESS_ENG + item.PROVINCE_ENG + "(省)";
                  }
                  if (!!item.CITY_ENG) {
                    item.FULL_ADDRESS_ENG = item.FULL_ADDRESS_ENG + item.CITY_ENG + "(市)";
                  }

                  if (!!item.ADDRESS_ENG) {
                    item.FULL_ADDRESS_ENG = item.FULL_ADDRESS_ENG + item.ADDRESS_ENG;
                  }

                  item.FULL_BIRTHD_ADDRESS_ENG = "";
                  if (!!item.BIRTH_NATION_ENG) {
                    item.FULL_BIRTHD_ADDRESS_ENG = item.BIRTH_NATION_ENG + "(国家)";
                  }

                  if (!!item.BIRTH_PROVINCE_ENG) {
                    item.FULL_BIRTHD_ADDRESS_ENG = item.FULL_BIRTHD_ADDRESS_ENG + item.BIRTH_PROVINCE_ENG + "(省)";
                  }

                  if (!!item.BIRTH_CITY_ENG) {
                    item.FULL_BIRTHD_ADDRESS_ENG = item.FULL_BIRTHD_ADDRESS_ENG + item.BIRTH_CITY_ENG + "(市)";
                  }


                  if (!!item.BIRTH_ADDRESS_ENG) {
                    item.FULL_BIRTHD_ADDRESS_ENG = item.FULL_BIRTHD_ADDRESS_ENG + item.BIRTH_ADDRESS_ENG;
                  }
                });

                bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], custTaxInfo);

                _.set(params, SAVE_PATH, custTaxInfo);
              } else {
                _.set(params, SAVE_PATH, []);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),
  pageActivated: function pageActivated(_this, groupId) {
    _.each(_this.groupDatas[GROUP_ID][MODULE_ID], function (module) {
      _this.busiLogic["CHECK_TAX_FLAG"](_this, module.FIELDS.TAX_RESIDENT_TYPE, module.FIELDS, module);
    });
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  "CHECK_TAX_FLAG": function CHECK_TAX_FLAG(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (field.DEFAULT_VALUE == "1" || field.DEFAULT_VALUE == "5") {
            setFeildData(fieldData, "FIELD_CONTROL", "1", ["TAX_RESIDENT_TYPE", "GET_INVEST_CERFLAG", "IS_FINANCIAL_INSTITUTION", "PASSIVE_NFE"]);
            setFeildData(fieldData, "DEFAULT_VALUE", "", ["TAX_RESIDENT_TYPE", "GET_INVEST_CERFLAG", "IS_FINANCIAL_INSTITUTION", "PASSIVE_NFE"]);
          } else {
            setFeildData(fieldData, "FIELD_CONTROL", "0", ["SEL_NO_TAXPAYERID_REASON1", "SEL_NO_TAXPAYERID_REASON2", "SEL_NO_TAXPAYERID_REASON3", "TAXPAYER_IDNO", "TAXPAYER_IDNO2", "TAXPAYER_IDNO3", "NO_TAXPAYERID_REASON", "NO_TAXPAYERID_REASON2", "NO_TAXPAYERID_REASON3", "IS_SAME_LEGAL_REP", "GET_INVEST_CERFLAG", "PASSIVE_NFE"]);
          }
        } else {
          setFeildData(fieldData, "FIELD_CONTROL", "1", ["TAX_RESIDENT_TYPE", "GET_INVEST_CERFLAG", "IS_FINANCIAL_INSTITUTION", "PASSIVE_NFE"]);
          setFeildData(fieldData, "DEFAULT_VALUE", "", ["TAX_RESIDENT_TYPE", "GET_INVEST_CERFLAG", "IS_FINANCIAL_INSTITUTION", "PASSIVE_NFE"]);
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (field.DEFAULT_VALUE == "1" || field.DEFAULT_VALUE == "5") {
            setFeildData(fieldData, "FIELD_CONTROL", "1", ["TAX_RESIDENT_TYPE", "CUST_NAME", "GET_INVEST_CERFLAG"]);
            setFeildData(fieldData, "DEFAULT_VALUE", "", ["TAX_RESIDENT_TYPE", "CUST_NAME", "GET_INVEST_CERFLAG"]);
          } else {
            setFeildData(fieldData, "FIELD_CONTROL", "0", ["SEL_NO_TAXPAYERID_REASON1", "SEL_NO_TAXPAYERID_REASON2", "SEL_NO_TAXPAYERID_REASON3", "TAXPAYER_IDNO", "TAXPAYER_IDNO2", "TAXPAYER_IDNO3", "NO_TAXPAYERID_REASON", "NO_TAXPAYERID_REASON2", "NO_TAXPAYERID_REASON3", "IS_SAME_LEGAL_REP", "GET_INVEST_CERFLAG"]);
          }
        } else {
          setFeildData(fieldData, "FIELD_CONTROL", "1", ["TAX_RESIDENT_TYPE", "CUST_NAME", "GET_INVEST_CERFLAG"]);
          setFeildData(fieldData, "DEFAULT_VALUE", "", ["TAX_RESIDENT_TYPE", "CUST_NAME", "GET_INVEST_CERFLAG"]);
        }
      }
    }
  },
  "CHECK_IS_TAXPAYER_IDNO_1": function CHECK_IS_TAXPAYER_IDNO_1(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "0") {
              fieldData.TAXPAYER_IDNO.FIELD_CONTROL = "1";
              fieldData.SEL_NO_TAXPAYERID_REASON1.FIELD_CONTROL = "0";
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON1.isLongItem = false;
            } else {
              fieldData.TAXPAYER_IDNO.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON1.FIELD_CONTROL = "1";
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "1";

              fieldData.SEL_NO_TAXPAYERID_REASON1.DEFAULT_VALUE = "";
              fieldData.NO_TAXPAYERID_REASON.DEFAULT_VALUE = "";
              fieldData.TAXPAYER_IDNO.isLongItem = true;
            }
          }
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "0") {
              fieldData.TAXPAYER_IDNO.FIELD_CONTROL = "1";
              fieldData.SEL_NO_TAXPAYERID_REASON1.FIELD_CONTROL = "0";
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON1.isLongItem = false;
            } else {
              fieldData.TAXPAYER_IDNO.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON1.FIELD_CONTROL = "1";
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "1";
              fieldData.TAXPAYER_IDNO.isLongItem = true;

              fieldData.SEL_NO_TAXPAYERID_REASON1.DEFAULT_VALUE = "";
              fieldData.NO_TAXPAYERID_REASON.DEFAULT_VALUE = "";
            }
          }
        }
      }
    }
  },
  "CHECK_IS_TAXPAYER_IDNO_2": function CHECK_IS_TAXPAYER_IDNO_2(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "0") {
              fieldData.TAXPAYER_IDNO2.FIELD_CONTROL = "1";
              fieldData.SEL_NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON2.isLongItem = false;
            } else {
              fieldData.TAXPAYER_IDNO2.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";

              fieldData.SEL_NO_TAXPAYERID_REASON2.DEFAULT_VALUE = "";
              fieldData.NO_TAXPAYERID_REASON2.DEFAULT_VALUE = "";
              fieldData.TAXPAYER_IDNO2.isLongItem = true;
            }
          }
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "0") {
              fieldData.TAXPAYER_IDNO2.FIELD_CONTROL = "1";
              fieldData.SEL_NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON2.isLongItem = false;
            } else {
              fieldData.TAXPAYER_IDNO2.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";
              fieldData.TAXPAYER_IDNO2.isLongItem = true;

              fieldData.SEL_NO_TAXPAYERID_REASON2.DEFAULT_VALUE = "";
              fieldData.NO_TAXPAYERID_REASON2.DEFAULT_VALUE = "";
            }
          }
        }
      }
    }
  },
  "CHECK_IS_TAXPAYER_IDNO_3": function CHECK_IS_TAXPAYER_IDNO_3(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "0") {
              fieldData.TAXPAYER_IDNO3.FIELD_CONTROL = "1";
              fieldData.SEL_NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON3.isLongItem = false;
            } else {
              fieldData.TAXPAYER_IDNO3.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";

              fieldData.SEL_NO_TAXPAYERID_REASON3.DEFAULT_VALUE = "";
              fieldData.NO_TAXPAYERID_REASON3.DEFAULT_VALUE = "";
              fieldData.TAXPAYER_IDNO3.isLongItem = true;
            }
          }
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "0") {
              fieldData.TAXPAYER_IDNO3.FIELD_CONTROL = "1";
              fieldData.SEL_NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON3.isLongItem = false;
            } else {
              fieldData.TAXPAYER_IDNO3.FIELD_CONTROL = "0";
              fieldData.SEL_NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";
              fieldData.TAXPAYER_IDNO3.isLongItem = true;

              fieldData.SEL_NO_TAXPAYERID_REASON3.DEFAULT_VALUE = "";
              fieldData.NO_TAXPAYERID_REASON3.DEFAULT_VALUE = "";
            }
          }
        }
      }
    }
  },
  "CHECK_SEL_NO_TAXPAYERID_REASON1": function CHECK_SEL_NO_TAXPAYERID_REASON1(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "1") {
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "1";
              field.isLongItem = true;
            } else {
              field.isLongItem = false;
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "0";
            }
          }
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "1") {
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "1";
              field.isLongItem = true;
            } else {
              field.isLongItem = false;
              fieldData.NO_TAXPAYERID_REASON.FIELD_CONTROL = "0";
            }
          }
        }
      }
    }
  },
  "CHECK_SEL_NO_TAXPAYERID_REASON2": function CHECK_SEL_NO_TAXPAYERID_REASON2(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "1") {
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";
              field.isLongItem = true;
            } else {
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
              field.isLongItem = false;
            }
          }
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "1") {
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";
              field.isLongItem = true;
            } else {
              fieldData.NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
              field.isLongItem = false;
            }
          }
        }
      }
    }
  },
  "CHECK_SEL_NO_TAXPAYERID_REASON3": function CHECK_SEL_NO_TAXPAYERID_REASON3(_this, field, fieldData, md) {
    if (md != null) {
      if (md.MODULE_ID == "MA_CUST_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "1") {
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";
              field.isLongItem = true;
            } else {
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
              field.isLongItem = false;
            }
          }
        }
      }
      if (md.MODULE_ID == "MA_CONTROLER_TAX_INFO_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 1 && fieldData.TAX_RESIDENT_TYPE.DEFAULT_VALUE != 5) {
            if (field.DEFAULT_VALUE == "1") {
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";
              field.isLongItem = true;
            } else {
              fieldData.NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
              field.isLongItem = false;
            }
          }
        }
      }
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizTaxInfo/bizTaxContolInfoNode.js
// module id = 128
// module chunks = 2